import { render, staticRenderFns } from "./NewServices.vue?vue&type=template&id=70dd76da&"
import script from "./NewServices.vue?vue&type=script&lang=js&"
export * from "./NewServices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports